import React from 'react';
import { Link } from 'react-router-dom';
import logoU from '~/assets/images/logo-u.png';
import imgSignin from '~/assets/images/signin-logo.png';
import imgDates from '../../assets/images/dates.png';
import styles from './edit-link-sent.module.scss';
import { CONTACT_EMAIL } from '~/constants';

const EditLinkSent = () => (
  <div className={styles.editLinkSent}>
    <Link to="/" className={styles.logo}>
      <img src={logoU} alt="Logo Coopérative U" />
    </Link>
    <div className={styles.container}>
      <div className={styles.imgContainer}>
        <h1>Bienvenue au</h1>
        <img src={imgSignin} alt="Bienvenue au salon U" />
        <img src={imgDates} alt="Dates du salon" className={styles.dates}/>
      </div>
      <div className={styles.form}>
        <h2>
          Un email contenant un lien sécurisé vous a été envoyé pour modifier votre inscription.
          <br/>Pensez à vérifier vos spams.
        </h2>
        <span className={styles.caption}>
          Je ne reçois pas d&apos;email. Contactez-nous : {CONTACT_EMAIL}
        </span>
      </div>
    </div>
  </div>
);

export default EditLinkSent;
